import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Typography,
  Grid,
  makeStyles,
  CircularProgress,
  Button as MuiButton,
} from "@material-ui/core";
import BusinessIcon from "@material-ui/icons/Business";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import StarIcon from "@material-ui/icons/Star";
import WarningIcon from "@material-ui/icons/Warning";
import CheckIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import PublicIcon from "@material-ui/icons/Public";
import LanguageIcon from "@material-ui/icons/Language";
import SecurityIcon from "@material-ui/icons/Security";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import PhoneIcon from "@material-ui/icons/Phone";
import LaunchIcon from "@material-ui/icons/Launch";
import InfoIcon from "@material-ui/icons/Info";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import WorkIcon from "@material-ui/icons/Work";
import PersonIcon from "@material-ui/icons/Person";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import GroupIcon from "@material-ui/icons/Group";
import FingerprintIcon from "@material-ui/icons/Fingerprint";
import DeviceHubIcon from "@material-ui/icons/DeviceHub";
import AiChat from 'components/AiChat/AiChat';
import Button from "components/shared/Button";
import CreditCost from "components/shared/CreditCost";
import ReportEmptyState from "components/shared/ReportEmptyState";
import { Icon } from "styles";
import Chart from "react-apexcharts";
import {
  getReputationReportStatus,
  requestReputationReport,
  getReputationReport,
  getReputationReportPhoto,
  getChameleonCarrier,
  getCrashRisk,
  getInspectionTrend,
} from "../../../../../actions/applicants";
import strings from "strings";
import { getAgentChatStatus } from "../../../../../actions/agentChat";
import AuthService from "../../../../../tools/AuthService";

const useStyles = makeStyles((theme) => ({
  bbbAccreditedBadge: {
    borderRadius: "9999px",
    padding: "4px 12px",
    fontSize: "0.75rem",
    fontWeight: 600,
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    marginLeft: theme.spacing(1),
  },
  bbbAccreditedYes: {
    backgroundColor: "rgba(34, 197, 94, 0.1)",
    color: "#22c55e",
    border: "1px solid rgba(34, 197, 94, 0.3)",
  },
  bbbAccreditedNo: {
    backgroundColor: "rgba(156, 163, 175, 0.1)",
    color: "#6b7280",
    border: "1px solid rgba(156, 163, 175, 0.3)",
  },
  bbbRatingLetter: {
    fontSize: "1.5rem",
    fontWeight: 700,
    color: "#22c55e",
    backgroundColor: "rgba(34, 197, 94, 0.1)",
    borderRadius: 8,
    padding: theme.spacing(0.5, 1.5),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 40,
  },
  bbbRatingLetterWarning: {
    color: "#f59e0b",
    backgroundColor: "rgba(245, 158, 11, 0.1)",
  },
  bbbRatingLetterError: {
    color: "#ef4444",
    backgroundColor: "rgba(239, 68, 68, 0.1)",
  },
  bbbMetricsGrid: {
    display: "grid",
    gap: theme.spacing(1.5),
    gridTemplateColumns: "repeat(2, 1fr)",
    marginTop: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      gridTemplateColumns: "repeat(4, 1fr)",
    },
  },
  bbbMetricItem: {
    padding: theme.spacing(1.5),
    borderRadius: 8,
    backgroundColor: "rgba(248, 250, 252, 0.8)",
    border: "1px solid #e4e7ec",
  },
  bbbMetricValue: {
    fontSize: "1.125rem",
    fontWeight: 600,
    color: "#111827",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 40
  },

  bbbMetricLabel: {
    fontSize: "0.7rem",
    fontWeight: 500,
    color: "#6b7280",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    marginTop: theme.spacing(0.25),
  },
  ratingReasonsList: {
    marginTop: theme.spacing(1.5),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
  ratingReasonItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(1),
    fontSize: "0.875rem",
    color: "#6b7280",
  },
  ratingReasonIcon: {
    marginTop: 2,
    width: 16,
    height: 16,
    color: "#22c55e",
    flexShrink: 0,
  },
  categoriesList: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(0.75),
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
  },
  categoryChip: {
    padding: "4px 10px",
    borderRadius: 6,
    backgroundColor: "rgba(59, 130, 246, 0.1)",
    color: "#3b82f6",
    fontSize: "0.75rem",
    fontWeight: 500,
  },
  iconWrapperBlue: {
    backgroundColor: "rgba(59, 130, 246, 0.1)",
    "& .MuiSvgIcon-root": {
      color: "#3b82f6",
    },
  },
  root: {
    padding: theme.spacing(4),
    boxShadow: "0 0 0 1px #e4e7ec",
    minHeight: "400px",
    position: "relative",
  },
  infoCard: {
    borderRadius: 16,
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    background: "#fff",
    boxShadow: "0 2px 8px rgba(35,38,59,0.07)",
    border: "1px solid #e4e7ec",
  },
  panel: {
    borderRadius: 14,
    padding: theme.spacing(2.5),
    background: "#fff",
    minWidth: 200,
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(2),
    flex: 1,
    boxShadow: "0 2px 8px rgba(35,38,59,0.06)",
    border: "1px solid #e4e7ec",
  },
  card: {
    padding: theme.spacing(3),
    background: "#fff",
    borderRadius: 16,
    boxShadow: "0 2px 8px rgba(35,38,59,0.08)",
    border: "1px solid #e4e7ec",
    marginBottom: theme.spacing(2),
  },
  modernCard: {
    border: "1px solid #e4e7ec",
    background: "#fff",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    padding: theme.spacing(3),
    borderRadius: 12,
    marginBottom: theme.spacing(2),
  },
  companyCard: {
    border: "1px solid #e4e7ec",
    background: "#fff",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    padding: theme.spacing(3),
    borderRadius: 12,
    marginBottom: theme.spacing(3),
  },
  companyHeader: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(3),
  },
  companyIconWrapper: {
    borderRadius: 12,
    backgroundColor: "rgba(59, 130, 246, 0.1)",
    padding: theme.spacing(1.5),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& .MuiSvgIcon-root": {
      color: "#3b82f6",
      fontSize: "1.5rem",
    },
  },
  companyInfo: {
    flex: 1,
  },
  companyName: {
    fontSize: "1.5rem",
    fontWeight: 600,
    color: "#111827",
    letterSpacing: "-0.025em",
    lineHeight: 1.2,
    marginBottom: theme.spacing(1),
  },
  companyAddress: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    fontSize: "0.875rem",
    color: "#6b7280",
  },
  metricsGrid: {
    display: "grid",
    gap: theme.spacing(2),
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    [theme.breakpoints.up("md")]: {
      gridTemplateColumns: "repeat(4, 1fr)",
    },
  },
  metricTextStack: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.25),
    alignItems: "flex-start",
  },
  metricTextSecondary: {
    fontSize: "0.8125rem",
    fontWeight: 500,
    color: "#4b5563",
  },
  metricCard: {
    borderRadius: 12,
    border: "1px solid #e4e7ec",
    backgroundColor: "rgba(248, 250, 252, 0.5)",
    padding: theme.spacing(2),
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
  },
  metricLabel: {
    fontSize: "0.75rem",
    fontWeight: 500,
    color: "#6b7280",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    marginBottom: theme.spacing(1),
  },
  metricValue: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  metricText: {
    fontSize: "1.125rem",
    fontWeight: 600,
    color: "#111827",
  },
  riskAnalysisCard: {
    border: "1px solid #e4e7ec",
    background: "#fff",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    padding: theme.spacing(3),
    borderRadius: 12,
    marginBottom: theme.spacing(3),
  },
  riskAnalysisHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
  },
  riskIconWrapper: {
    borderRadius: 12,
    backgroundColor: "rgba(59, 130, 246, 0.1)",
    padding: theme.spacing(1.25),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& .MuiSvgIcon-root": {
      color: "#3b82f6",
      fontSize: "1.25rem",
    },
  },
  riskAnalysisTitle: {
    fontWeight: 600,
    color: "#111827",
    fontSize: "1rem",
  },
  analysisSection: {
    borderRadius: 12,
    backgroundColor: "rgba(156, 163, 175, 0.1)",
    padding: theme.spacing(2.5),
    border: "1px solid rgba(209, 213, 219, 0.5)",
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  analysisSectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
  },
  analysisSectionTitle: {
    fontSize: "0.875rem",
    fontWeight: 600,
    color: "#111827",
  },
  analysisText: {
    fontSize: "0.875rem",
    color: "#111827",
    lineHeight: 1.6,
  },
  recommendationsList: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.25),
  },
  recommendationItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(1.25),
  },
  recommendationIcon: {
    marginTop: 2,
    width: 16,
    height: 16,
    flexShrink: 0,
  },
  recommendationText: {
    fontSize: "0.875rem",
    color: "#6b7280",
    lineHeight: 1.6,
    "& strong": {
      color: "#111827",
    },
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(2),
  },
  cardHeaderLeft: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },
  iconWrapper: {
    borderRadius: 12,
    padding: theme.spacing(1.25),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  iconWrapperSuccess: {
    backgroundColor: "rgba(34, 197, 94, 0.1)",
    "& .MuiSvgIcon-root": {
      color: "#22c55e",
    },
  },
  iconWrapperError: {
    backgroundColor: "rgba(239, 68, 68, 0.1)",
    "& .MuiSvgIcon-root": {
      color: "#ef4444",
    },
  },
  iconWrapperNeutral: {
    backgroundColor: "rgba(100, 116, 139, 0.1)",
    "& .MuiSvgIcon-root": {
      color: "#64748b",
    },
  },
  badge: {
    borderRadius: "9999px",
    padding: "4px 12px",
    fontSize: "0.75rem",
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
  },
  badgeSuccess: {
    border: "1px solid rgba(34, 197, 94, 0.3)",
    color: "#22c55e",
    backgroundColor: "rgba(34, 197, 94, 0.05)",
  },
  badgeError: {
    border: "1px solid rgba(239, 68, 68, 0.3)",
    color: "#ef4444",
    backgroundColor: "rgba(239, 68, 68, 0.05)",
  },
  badgeNeutral: {
    border: "1px solid rgba(148, 163, 184, 0.4)",
    color: "#64748b",
    backgroundColor: "rgba(148, 163, 184, 0.08)",
  },
  fieldLabel: {
    fontSize: "0.75rem",
    fontWeight: 500,
    color: "#6b7280",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    marginBottom: theme.spacing(0.75),
  },
  fieldValue: {
    fontWeight: 500,
    color: "#111827",
    fontSize: "0.875rem",
  },
  dotNumber: {
    fontFamily: "monospace",
    fontSize: "1.125rem",
    fontWeight: 600,
    color: "#111827",
  },
  addressContainer: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(1),
  },
  ratingContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: "rgba(156, 163, 175, 0.1)",
    padding: theme.spacing(1.75),
    border: "1px solid rgba(209, 213, 219, 0.5)",
    marginTop: theme.spacing(1),
  },
  ratingLeft: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
  },
  divider: {
    height: "16px",
    width: "1px",
    backgroundColor: "#d1d5db",
  },
  actionButtons: {
    display: "flex",
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  actionButton: {
    flex: 1,
    borderRadius: "9999px",
    border: "1px solid rgba(59, 130, 246, 0.2)",
    backgroundColor: "transparent",
    color: "#3b82f6",
    textTransform: "none",
    padding: theme.spacing(1, 2),
    fontSize: "0.875rem",
    "&:hover": {
      backgroundColor: "rgba(59, 130, 246, 0.05)",
      borderColor: "rgba(59, 130, 246, 0.3)",
    },
  },
  notFoundContainer: {
    borderRadius: 12,
    backgroundColor: "rgba(156, 163, 175, 0.1)",
    padding: theme.spacing(2),
    border: "1px solid rgba(209, 213, 219, 0.5)",
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(1),
  },
  imageContainer: {
    borderRadius: 12,
    overflow: "hidden",
    border: "1px solid #e4e7ec",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
  },
  mapContainer: {
    borderRadius: 8,
    overflow: "hidden",
    border: "1px solid #e4e7ec",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
  },
  section: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  iconBox: {
    width: 44,
    height: 44,
    background: "#f6f7fb",
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(2),
    border: "1px solid #e4e7ec",
  },
  greenDot: { color: "#29cc39" },
  redDot: { color: "#ff2340" },
  yellowDot: { color: "#ffc43c" },
  metricDot: {
    height: 8,
    width: 8,
    borderRadius: "50%",
    flexShrink: 0,
  },
  successDot: {
    backgroundColor: "#22c55e",
  },
  warningDot: {
    backgroundColor: "#f59e0b",
  },
  errorDot: {
    backgroundColor: "#ef4444",
  },
  neutralDot: {
    backgroundColor: "#94a3b8",
  },
  label: {
    fontWeight: "bold",
    fontSize: "0.95rem",
    marginBottom: theme.spacing(0.5),
    color: theme.palette.text.secondary,
  },
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(4),
    color: theme.palette.text.secondary,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    height: "100%",
  },
  headerContainer: {
    marginBottom: 24,
  },
  analysisContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
  contentSectionSpacing: {
    marginTop: 16,
  },
  smallInfoIcon: {
    marginTop: 2,
    width: 16,
    height: 16,
    color: "#6b7280",
  },
  cardTitle: {
    fontWeight: 600,
    color: "#111827",
  },
  badgeIcon: {
    width: 14,
    height: 14,
  },
  smallLocationIcon: {
    marginTop: 2,
    width: 16,
    height: 16,
    color: "#6b7280",
  },
  infoText: {
    fontSize: "0.875rem",
    color: "#6b7280",
    lineHeight: 1.6,
  },
  fieldText: {
    fontSize: "0.875rem",
    color: "#111827",
  },
  sectionsSpacing: {
    marginTop: 24,
  },
  analysisIconError: {
    color: "#ef4444",
  },
  analysisIconSuccess: {
    color: "#22c55e",
  },
  analysisIconWarning: {
    color: "#f59e0b",
  },
  analysisUnderwritingTitle: {
    marginBottom: 16,
  },
  companyImage: {
    width: "100%",
    height: "192px",
    objectFit: "cover",
  },
  mapIframe: {
    border: 0,
  },
  mapPlaceholder: {
    height: "192px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f9fafb",
  },
  locationContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
  googleLinkContainer: {
    marginLeft: 24,
  },
  googleLink: {
    fontSize: "0.75rem",
    color: "#3b82f6",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    gap: 4,
  },
  smallLaunchIcon: {
    width: 12,
    height: 12,
  },
  starIcon: {
    width: 16,
    height: 16,
    color: "#fbbf24",
    fill: "#fbbf24",
  },
  ratingText: {
    fontWeight: 600,
    color: "#111827",
  },
  ratingsCount: {
    fontSize: "0.875rem",
    color: "#6b7280",
  },
  websiteIcon: {
    width: 14,
    height: 14,
  },
  phoneIcon: {
    width: 14,
    height: 14,
  },
  locationIconWithShrink: {
    marginTop: 2,
    width: 16,
    height: 16,
    color: "#6b7280",
    flexShrink: 0,
  },
  indeedMetricsGrid: {
    display: "grid",
    gap: theme.spacing(1.5),
    gridTemplateColumns: "repeat(2, 1fr)",
    marginTop: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      gridTemplateColumns: "repeat(3, 1fr)",
    },
  },
  indeedMetricItem: {
    padding: theme.spacing(1.5),
    borderRadius: 8,
    backgroundColor: "rgba(248, 250, 252, 0.8)",
    border: "1px solid #e4e7ec",
  },
  indeedMetricValue: {
    fontSize: "1.125rem",
    fontWeight: 600,
    color: "#111827",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 40
  },
  indeedMetricLabel: {
    fontSize: "0.7rem",
    fontWeight: 500,
    color: "#6b7280",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    marginTop: theme.spacing(0.25),
  },
  indeedRatingContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: "rgba(34, 197, 94, 0.1)",
    padding: theme.spacing(1.75),
    border: "1px solid rgba(34, 197, 94, 0.3)",
    marginTop: theme.spacing(1),
  },
  indeedRatingLeft: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
  },
  indeedRatingScore: {
    fontSize: "1.5rem",
    fontWeight: 700,
    color: "#22c55e",
  },
  indeedRatingText: {
    fontWeight: 600,
    color: "#111827",
  },
  indeedReviewsCount: {
    fontSize: "0.875rem",
    color: "#6b7280",
  },

  /* ── Chameleon Carrier ── */
  chameleonBadgeWarning: {
    border: "1px solid rgba(245,158,11,0.35)",
    color: "#b45309",
    backgroundColor: "rgba(245,158,11,0.08)",
  },
  chameleonIconWrapperWarning: {
    backgroundColor: "rgba(245,158,11,0.1)",
    "& .MuiSvgIcon-root": {
      color: "#f59e0b",
    },
  },

  chameleonBreakdownRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(0.875, 0),
    borderBottom: "1px solid #f3f4f6",
    "&:last-child": { borderBottom: "none" },
  },
  chameleonBreakdownLabel: {
    minWidth: 210,
    fontSize: "0.82rem",
    color: "#374151",
    fontWeight: 500,
  },
  chameleonBreakdownMax: {
    fontSize: "0.72rem",
    color: "#9ca3af",
    fontWeight: 400,
  },
  chameleonBreakdownBarWrap: {
    flex: 1,
    height: 12,
    borderRadius: 6,
    background: "#f3f4f6",
    overflow: "hidden",
  },
  chameleonBreakdownBarFill: {
    height: "100%",
    borderRadius: 6,
    transition: "width 0.5s ease",
  },
  chameleonBreakdownBarActive: {
    background: "linear-gradient(90deg, #b91c1c, #ef4444)",
  },
  chameleonBreakdownBarMedium: {
    background: "linear-gradient(90deg, #d97706, #fbbf24)",
  },
  chameleonBreakdownBarEmpty: {
    background: "#e5e7eb",
    width: "4px !important",
  },
  chameleonBreakdownScore: {
    minWidth: 36,
    textAlign: "right",
    fontSize: "0.82rem",
    fontWeight: 600,
    color: "#374151",
  },
  chameleonNetworkBody: {
    padding: theme.spacing(2, 2.5),
    background: "#fff",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
  },
  chameleonMatchGroup: {
    borderRadius: 10,
    border: "1px solid #e5e7eb",
    overflow: "hidden",
  },
  chameleonMatchGroupHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(1.25, 2),
    background: "#f9fafb",
    borderBottom: "1px solid #e5e7eb",
    flexWrap: "wrap",
  },
  chameleonMatchType: {
    fontSize: "0.75rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    color: "#374151",
  },
  chameleonMatchValue: {
    fontSize: "0.78rem",
    color: "#6b7280",
    fontFamily: "monospace",
  },
  chameleonReincarnationBadge: {
    marginLeft: "auto",
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    padding: "2px 8px",
    borderRadius: 9999,
    fontSize: "0.65rem",
    fontWeight: 700,
    background: "rgba(239,68,68,0.1)",
    color: "#ef4444",
    border: "1px solid rgba(239,68,68,0.3)",
  },
  chameleonSiblingRow: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1.25, 2),
    borderBottom: "1px solid #f3f4f6",
    gap: theme.spacing(1.5),
    "&:last-child": { borderBottom: "none" },
    flexWrap: "wrap",
  },
  chameleonSiblingDot: {
    fontFamily: "monospace",
    fontSize: "0.78rem",
    fontWeight: 600,
    color: "#6b7280",
    minWidth: 72,
  },
  chameleonSiblingName: {
    flex: 1,
    fontSize: "0.82rem",
    color: "#111827",
    fontWeight: 500,
    minWidth: 120,
  },
  chameleonAuthorityBadge: {
    fontSize: "0.65rem",
    fontWeight: 700,
    padding: "2px 7px",
    borderRadius: 4,
    letterSpacing: "0.04em",
  },
  chameleonAuthorityActive: {
    background: "rgba(34,197,94,0.1)",
    color: "#15803d",
    border: "1px solid rgba(34,197,94,0.3)",
  },
  chameleonAuthorityNone: {
    background: "rgba(156,163,175,0.1)",
    color: "#6b7280",
    border: "1px solid rgba(156,163,175,0.3)",
  },
  chameleonRevokedBadge: {
    fontSize: "0.65rem",
    fontWeight: 700,
    padding: "2px 7px",
    borderRadius: 4,
    background: "rgba(239,68,68,0.1)",
    color: "#ef4444",
    border: "1px solid rgba(239,68,68,0.3)",
  },

  /* ── Crash Analysis & Inspection Analysis shared ── */
  ratingBadgeCritical: {
    background: "rgba(239,68,68,0.1)",
    color: "#ef4444",
    border: "1px solid rgba(239,68,68,0.3)",
    borderRadius: "9999px",
    padding: "2px 8px",
    fontSize: "0.65rem",
    fontWeight: 700,
  },
  ratingBadgeElevated: {
    background: "rgba(245,158,11,0.1)",
    color: "#b45309",
    border: "1px solid rgba(245,158,11,0.3)",
    borderRadius: "9999px",
    padding: "2px 8px",
    fontSize: "0.65rem",
    fontWeight: 700,
  },
  ratingBadgeWatch: {
    background: "rgba(59,130,246,0.1)",
    color: "#1d4ed8",
    border: "1px solid rgba(59,130,246,0.3)",
    borderRadius: "9999px",
    padding: "2px 8px",
    fontSize: "0.65rem",
    fontWeight: 700,
  },
  ratingBadgeSafe: {
    background: "rgba(34,197,94,0.1)",
    color: "#15803d",
    border: "1px solid rgba(34,197,94,0.3)",
    borderRadius: "9999px",
    padding: "2px 8px",
    fontSize: "0.65rem",
    fontWeight: 700,
  },
  scoreGaugeWrap: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(2),
    borderRadius: 12,
    border: "1px solid #e4e7ec",
    background: "rgba(248,250,252,0.5)",
  },
  scoreNumber: {
    fontSize: "2.5rem",
    fontWeight: 700,
    lineHeight: 1,
    color: "#111827",
  },
  scoreMax: {
    fontSize: "1rem",
    color: "#9ca3af",
    fontWeight: 400,
  },
  componentRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(0.875, 0),
    borderBottom: "1px solid #f3f4f6",
    "&:last-child": { borderBottom: "none" },
    flexWrap: "wrap",
  },
  componentLabel: {
    minWidth: 200,
    fontSize: "0.82rem",
    color: "#374151",
    fontWeight: 500,
  },
  componentBarWrap: {
    flex: 1,
    minWidth: 80,
    height: 10,
    borderRadius: 5,
    background: "#f3f4f6",
    overflow: "hidden",
  },
  componentBarFill: {
    height: "100%",
    borderRadius: 5,
    transition: "width 0.5s ease",
  },
  componentScore: {
    minWidth: 36,
    textAlign: "right",
    fontSize: "0.82rem",
    fontWeight: 600,
    color: "#374151",
  },
  trendBadgeStable: {
    background: "rgba(59,130,246,0.1)",
    color: "#1d4ed8",
    border: "1px solid rgba(59,130,246,0.3)",
  },
  trendBadgeImproving: {
    background: "rgba(34,197,94,0.1)",
    color: "#15803d",
    border: "1px solid rgba(34,197,94,0.3)",
  },
  trendBadgeDegrading: {
    background: "rgba(239,68,68,0.1)",
    color: "#ef4444",
    border: "1px solid rgba(239,68,68,0.3)",
  },
  comparisonTable: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "0.82rem",
  },
  comparisonTh: {
    textAlign: "left",
    padding: "6px 10px",
    background: "#f9fafb",
    borderBottom: "1px solid #e5e7eb",
    fontWeight: 600,
    color: "#374151",
    fontSize: "0.75rem",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
  },
  comparisonTd: {
    padding: "7px 10px",
    borderBottom: "1px solid #f3f4f6",
    color: "#374151",
    verticalAlign: "middle",
  },
  changeBetter: { color: "#22c55e", fontWeight: 600 },
  changeWorse: { color: "#ef4444", fontWeight: 600 },
  changeFlat: { color: "#9ca3af", fontWeight: 500 },
}));

/* ─────────────────────────────────────────────
   Chameleon Carrier Analysis
───────────────────────────────────────────── */
const CHAMELEON_SCORE_BREAKDOWN = [
  { key: "busAddress", label: "Business Address match", max: 3.0 },
  { key: "phone", label: "Phone number match", max: 2.0 },
  { key: "fuzzyName", label: "Fuzzy legal-name match", max: 2.0 },
  { key: "reincarnation", label: "Reincarnation pattern", max: 2.0 },
  { key: "undeliverable", label: "Undeliverable address", max: 0.5 },
  { key: "mailAddress", label: "Mail address match", max: 1.5 },
  { key: "fax", label: "Fax number match", max: 1.0 },
  { key: "mailPhone", label: "Mail phone match", max: 1.0 },
  { key: "mailFax", label: "Mail fax match", max: 0.5 },
];

const CHAMELEON_TOTAL_MAX = CHAMELEON_SCORE_BREAKDOWN.reduce((s, i) => s + i.max, 0);

const CHAMELEON_MATCH_TYPE_LABELS = {
  BUS_ADDRESS: "Business Address",
  PHONE: "Phone Number",
  FAX: "Fax Number",
  FUZZY_NAME: "Fuzzy Legal Name",
  MAIL_ADDRESS: "Mail Address",
  MAIL_PHONE: "Mail Phone",
  MAIL_FAX: "Mail Fax",
};

const CHAMELEON_AUTHORITY_LABELS = {
  A: "Active",
  N: "None",
  I: "Inactive",
};

function ChameleonCarrier({ dotNumber, applicationId }) {
  const classes = useStyles();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!dotNumber) {
      setLoading(false);
      return;
    }
    setLoading(true);
    getChameleonCarrier(applicationId, dotNumber)
      .then((res) => setData(res))
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, [dotNumber, applicationId]);

  if (loading) {
    return (
      <Box style={{ display: "flex", justifyContent: "center", padding: 24 }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (error || !data || Object.keys(data).length === 0) {
    return (
        <Box className={classes.modernCard}>
          <div className={classes.cardHeader}>
            <div className={classes.cardHeaderLeft}>
              <div className={classes.iconWrapper}>
                <FingerprintIcon />
              </div>
              <Typography variant="h6" className={classes.cardTitle}>
                Chameleon Carrier Analysis
              </Typography>
            </div>
          </div>
          <Box style={{ padding: "16px 24px" }}>
            <Typography style={{ color: "#6b7280", fontSize: "0.875rem" }}>
              No chameleon carrier data found for this DOT number.
            </Typography>
          </Box>
        </Box>
    );
  }

  const reincarnationCount = (data.relatedCarriers || []).filter((c) => c.reincarnation).length;
  const computedDate = data.computedAt
    ? new Date(data.computedAt).toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    })
    : null;

  const alertText =
    (data.riskLevel || "").toUpperCase() === "HIGH"
      ? "The subject carrier shows high chameleon-pattern indicators. Manual verification is recommended before any contract renewal or new appointment."
      : (data.riskLevel || "").toUpperCase() === "MEDIUM"
        ? "The subject carrier shows moderate chameleon-pattern indicators. Additional due diligence is advisable before appointment."
        : "The subject carrier shows low chameleon-pattern indicators. Standard verification procedures apply.";

  const [alertFirst, ...alertRest] = alertText.split(". ");

  const riskBadgeClass =
    (data.riskLevel || "").toUpperCase() === "HIGH"
      ? classes.badgeError
      : (data.riskLevel || "").toUpperCase() === "MEDIUM"
        ? classes.chameleonBadgeWarning
        : classes.badgeSuccess;

  const riskIconWrapperClass =
    (data.riskLevel || "").toUpperCase() === "HIGH"
      ? classes.iconWrapperError
      : (data.riskLevel || "").toUpperCase() === "MEDIUM"
        ? classes.chameleonIconWrapperWarning
        : classes.iconWrapperSuccess;

  return (
    <Box className={classes.modernCard}>
      <div className={classes.cardHeader}>
        <div className={classes.cardHeaderLeft}>
          <div className={`${classes.iconWrapper} ${riskIconWrapperClass}`}>
            <FingerprintIcon />
          </div>
          <div>
            <Typography variant="h6" className={classes.cardTitle}>
              Chameleon Carrier Analysis
            </Typography>
            {computedDate && (
              <Typography style={{ fontSize: "0.75rem", color: "#6b7280", marginTop: 1 }}>
                {strings.APPLICANT.REPUTATION_REPORT.COMPUTED} {computedDate}
              </Typography>
            )}
          </div>
        </div>
        <div className={`${classes.badge} ${riskBadgeClass}`}>
          <WarningIcon className={classes.badgeIcon} />
          {data.riskLevel} {strings.APPLICANT.REPUTATION_REPORT.RISK}
        </div>
      </div>

      <Box className={classes.contentSectionSpacing}>
        <Box className={classes.bbbMetricsGrid}>
          <Box className={classes.bbbMetricItem}>
            <Typography className={classes.bbbMetricValue}>
              {data.clusterCount ?? "—"}
            </Typography>
            <Typography className={classes.bbbMetricLabel}>{strings.APPLICANT.REPUTATION_REPORT.MATCH_CLUSTERS}</Typography>
          </Box>
          <Box className={classes.bbbMetricItem}>
            <Typography className={classes.bbbMetricValue}>
              {data.relatedDotCount ?? "—"}
            </Typography>
            <Typography className={classes.bbbMetricLabel}>{strings.APPLICANT.REPUTATION_REPORT.RELATED_DOT_NUMBERS}</Typography>
          </Box>
          <Box className={classes.bbbMetricItem}>
            <Typography className={classes.bbbMetricValue}>
              {reincarnationCount > 0 ? `${reincarnationCount}+` : "0"}
            </Typography>
            <Typography className={classes.bbbMetricLabel}>{strings.APPLICANT.REPUTATION_REPORT.REINCARNATION_CANDIDATES}</Typography>
          </Box>
          <Box className={classes.bbbMetricItem}>
            <Typography className={classes.bbbMetricValue}>
              {data.totalScore != null ? data.totalScore.toFixed(1) : "—"}
              <span style={{ fontSize: "0.8rem", fontWeight: 400, color: "#9ca3af", marginLeft: 2 }}>
                /{CHAMELEON_TOTAL_MAX.toFixed(1)}
              </span>
            </Typography>
            <Typography className={classes.bbbMetricLabel}>{strings.APPLICANT.REPUTATION_REPORT.TOTAL_SCORE}</Typography>
          </Box>
        </Box>

        {(data.hasReincarnationPattern || data.hasUndeliverableAddress) && (
          <div className={classes.categoriesList}>
            {data.hasReincarnationPattern && (
              <span className={`${classes.badge} ${classes.badgeError}`} style={{ borderRadius: 6, fontSize: "0.72rem" }}>
                <WarningIcon style={{ width: 12, height: 12 }} />
                &nbsp;{strings.APPLICANT.REPUTATION_REPORT.REINCARNATION_PATTERN}
              </span>
            )}
            {data.hasUndeliverableAddress && (
              <span className={`${classes.badge} ${classes.badgeError}`} style={{ borderRadius: 6, fontSize: "0.72rem" }}>
                <WarningIcon style={{ width: 12, height: 12 }} />
                &nbsp;{strings.APPLICANT.REPUTATION_REPORT.UNDELIVERABLE_ADDRESS}
              </span>
            )}
          </div>
        )}

        <div className={classes.analysisSection}>
          <div className={classes.analysisSectionHeader}>
            <InfoIcon className={classes.smallInfoIcon} />
            <Typography className={classes.analysisSectionTitle}>{strings.APPLICANT.REPUTATION_REPORT.RISK_SUMMARY}</Typography>
          </div>
          <Typography className={classes.analysisText}>
            <strong>{alertFirst}.</strong>
            {alertRest.length > 0 && <> {alertRest.join(". ")}</>}
          </Typography>
        </div>

        {data.scoreBreakdown && (
          <Box>
            <Typography className={classes.fieldLabel} style={{ marginBottom: 12 }}>
              {strings.APPLICANT.REPUTATION_REPORT.SCORE_BREAKDOWN}
            </Typography>
            <Box>
              {CHAMELEON_SCORE_BREAKDOWN.map((item) => {
                const score = data.scoreBreakdown[item.key] ?? 0;
                const ratio = item.max > 0 ? score / item.max : 0;
                const barClass =
                  ratio <= 0
                    ? classes.chameleonBreakdownBarEmpty
                    : ratio >= 0.6
                      ? classes.chameleonBreakdownBarActive
                      : classes.chameleonBreakdownBarMedium;
                return (
                  <div key={item.key} className={classes.chameleonBreakdownRow}>
                    <Typography className={classes.chameleonBreakdownLabel}>
                      {item.label}{" "}
                      <span className={classes.chameleonBreakdownMax}>
                        (max {item.max.toFixed(1)})
                      </span>
                    </Typography>
                    <div className={classes.chameleonBreakdownBarWrap}>
                      <div
                        className={`${classes.chameleonBreakdownBarFill} ${barClass}`}
                        style={{ width: `${Math.min(ratio * 100, 100)}%` }}
                      />
                    </div>
                    <Typography className={classes.chameleonBreakdownScore}>
                      {score.toFixed(1)}
                    </Typography>
                  </div>
                );
              })}
            </Box>
          </Box>
        )}

        {data.relatedCarriers && data.relatedCarriers.length > 0 && (
          <Box>
            <Typography className={classes.fieldLabel} style={{ marginBottom: 12, display: "flex", alignItems: "center", gap: 6 }}>
              <DeviceHubIcon style={{ width: 15, height: 15 }} />
              {strings.APPLICANT.REPUTATION_REPORT.ENTITY_CONNECTION_NETWORK}
            </Typography>
            <Box style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {data.relatedCarriers.map((carrier, idx) => (
                <div key={idx} className={classes.chameleonMatchGroup}>
                  <div className={classes.chameleonMatchGroupHeader}>
                    <Typography className={classes.chameleonMatchType}>
                      {CHAMELEON_MATCH_TYPE_LABELS[carrier.matchType] || carrier.matchType}
                    </Typography>
                    <Typography className={classes.chameleonMatchValue}>
                      · {carrier.matchValue}
                    </Typography>
                    {carrier.reincarnation && (
                      <span className={classes.chameleonReincarnationBadge}>
                        {strings.APPLICANT.REPUTATION_REPORT.REINCARNATION}
                      </span>
                    )}
                  </div>
                  {(carrier.siblings || []).map((sibling, sIdx) => (
                    <div key={sIdx} className={classes.chameleonSiblingRow}>
                      <Typography className={classes.chameleonSiblingDot}>
                        #{sibling.dotNumber}
                      </Typography>
                      <Typography className={classes.chameleonSiblingName}>
                        {sibling.legalName}
                      </Typography>
                      <span
                        className={`${classes.chameleonAuthorityBadge} ${sibling.commonAuthority === "A"
                          ? classes.chameleonAuthorityActive
                          : classes.chameleonAuthorityNone
                          }`}
                      >
                        {CHAMELEON_AUTHORITY_LABELS[sibling.commonAuthority] || sibling.commonAuthority}
                      </span>
                      {sibling.hasRevocation && (
                        <span className={classes.chameleonRevokedBadge}>{strings.APPLICANT.REPUTATION_REPORT.REVOKED}</span>
                      )}
                    </div>
                  ))}
                </div>
              ))}
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
}

/* ─────────────────────────────────────────────
   Crash Analysis
───────────────────────────────────────────── */
const RATING_COLOR = {
  CRITICAL: "#ef4444",
  ELEVATED: "#f59e0b",
  WATCH: "#3b82f6",
  SAFE: "#22c55e",
};

function getRatingBadgeClass(rating, classes) {
  switch ((rating || "").toUpperCase()) {
    case "CRITICAL": return classes.ratingBadgeCritical;
    case "ELEVATED": return classes.ratingBadgeElevated;
    case "WATCH": return classes.ratingBadgeWatch;
    default: return classes.ratingBadgeSafe;
  }
}

function getRiskBadgeClass(riskLevel, classes) {
  switch ((riskLevel || "").toUpperCase()) {
    case "HIGH": return classes.badgeError;
    case "MODERATE": return classes.chameleonBadgeWarning;
    default: return classes.badgeSuccess;
  }
}

function getRiskIconClass(riskLevel, classes) {
  switch ((riskLevel || "").toUpperCase()) {
    case "HIGH": return classes.iconWrapperError;
    case "MODERATE": return classes.chameleonIconWrapperWarning;
    default: return classes.iconWrapperSuccess;
  }
}

function CrashAnalysis({ dotNumber, applicationId }) {
  const classes = useStyles();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!dotNumber) { setLoading(false); return; }
    setLoading(true);
    getCrashRisk(applicationId, dotNumber)
      .then((res) => setData(res))
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, [dotNumber, applicationId]);

  if (loading) return (
    <Box style={{ display: "flex", justifyContent: "center", padding: 24 }}>
      <CircularProgress size={28} />
    </Box>
  );
  if (error || !data || Object.keys(data).length === 0) {
    return (
        <Box className={classes.modernCard}>
          <div className={classes.cardHeader}>
            <div className={classes.cardHeaderLeft}>
              <div className={classes.iconWrapper}>
                <WarningIcon />
              </div>
              <Typography variant="h6" className={classes.cardTitle}>
                Crash Analysis
              </Typography>
            </div>
          </div>
          <Box style={{ padding: "16px 24px" }}>
            <Typography style={{ color: "#6b7280", fontSize: "0.875rem" }}>
              No crash analysis data found for this DOT number.
            </Typography>
          </Box>
        </Box>
    );
  }
  const t = strings.APPLICANT.REPUTATION_REPORT;
  const computedDate = data.computedAt
    ? new Date(data.computedAt).toLocaleDateString("en-US", { day: "numeric", month: "short", year: "numeric" })
    : null;

  const riskBadgeClass = getRiskBadgeClass(data.riskLevel, classes);
  const riskIconClass = getRiskIconClass(data.riskLevel, classes);

  // Build score components for bar chart
  const componentKeys = ["crashFrequency", "crashSeverity", "inspectionOosRate", "violationSeverity", "basicSpread", "oosOrder"];
  const componentLabels = {
    crashFrequency: "Crash Frequency",
    crashSeverity: "Crash Severity",
    inspectionOosRate: "Inspection OOS Rate",
    violationSeverity: "Violation Severity",
    basicSpread: "BASIC Category Spread",
    oosOrder: "OOS Order",
  };

  const metricsData = data.metrics || {};
  const metricCards = [
    { label: t.CRASH_COUNT, value: metricsData.crashCount ?? "—" },
    { label: t.PREVENTABLE_CRASHES, value: metricsData.preventableCrashCount ?? "—" },
    { label: t.FATAL_CRASHES, value: metricsData.fatalCrashCount ?? "—" },
    { label: t.INJURY_CRASHES, value: metricsData.injuryCrashCount ?? "—" },
    { label: t.TOW_AWAY_CRASHES, value: metricsData.towAwayCrashCount ?? "—" },
    { label: t.INSPECTION_COUNT, value: metricsData.inspectionCount ?? "—" },
    { label: t.OOS_INSPECTIONS, value: metricsData.oosInspectionCount ?? "—" },
    { label: t.VIOLATION_COUNT, value: metricsData.violationCount ?? "—" },
  ];

  // Radial gauge chart for composite score
  const gaugeOptions = {
    chart: { type: "radialBar", sparkline: { enabled: true } },
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 135,
        track: { background: "#f3f4f6", strokeWidth: "97%" },
        dataLabels: {
          name: { show: false },
          value: {
            offsetY: 8,
            fontSize: "2rem",
            fontWeight: 700,
            color: "#111827",
            formatter: () => data.compositeScore?.toFixed(1) ?? "—",
          },
        },
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        type: "horizontal",
        colorStops: [
          { offset: 0, color: "#22c55e", opacity: 1 },
          { offset: 50, color: "#f59e0b", opacity: 1 },
          { offset: 100, color: "#ef4444", opacity: 1 },
        ],
      },
    },
    stroke: { lineCap: "round" },
    labels: [t.COMPOSITE_SCORE],
  };
  const gaugePercent = Math.min(Math.round((data.compositeScore ?? 0)), 100);

  return (
    <Box className={classes.modernCard}>
      {/* Header */}
      <div className={classes.cardHeader}>
        <div className={classes.cardHeaderLeft}>
          <div className={`${classes.iconWrapper} ${riskIconClass}`}>
            <WarningIcon />
          </div>
          <div>
            <Typography variant="h6" className={classes.cardTitle}>{t.CRASH_ANALYSIS}</Typography>
            {computedDate && (
              <Typography style={{ fontSize: "0.75rem", color: "#6b7280", marginTop: 1 }}>
                {t.COMPUTED} {computedDate}
              </Typography>
            )}
          </div>
        </div>
        <div className={`${classes.badge} ${riskBadgeClass}`}>
          <WarningIcon className={classes.badgeIcon} />
          {data.riskLevel} {t.RISK}
        </div>
      </div>

      <Box className={classes.contentSectionSpacing}>
        {/* Score gauge + summary stats */}
        <Grid container spacing={2} alignItems="stretch">
          <Grid item xs={12} sm={4}>
            <Box className={classes.scoreGaugeWrap} style={{ height: "100%" }}>
              <Chart
                options={gaugeOptions}
                series={[gaugePercent]}
                type="radialBar"
                height={180}
                width="100%"
              />
              <Typography className={classes.fieldLabel} style={{ marginTop: 4, textAlign: "center" }}>
                {t.COMPOSITE_SCORE} / 100
              </Typography>
              {data.riskThresholds && (
                <Typography style={{ fontSize: "0.72rem", color: "#9ca3af", textAlign: "center", marginTop: 2 }}>
                  {data.riskThresholds.distanceToNextLevel?.toFixed(1)} {t.POINTS} to {data.riskThresholds.nextLevel}
                </Typography>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} sm={8}>
            <Box style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 8, height: "100%" }}>
              {[
                { label: t.PEER_GROUP, value: data.peerGroupDescription || data.peerGroup },
                { label: t.PEER_GROUP_SIZE, value: data.peerGroupSize ? `${data.peerGroupSize.toLocaleString()} ${t.CARRIERS}` : "—" },
                { label: t.POWER_UNITS, value: data.powerUnits?.toLocaleString() ?? "—" },
                { label: t.DRIVER_COUNT, value: data.driverCount?.toLocaleString() ?? "—" },
              ].map((item) => (
                <Box key={item.label} className={classes.bbbMetricItem}>
                  <Typography className={classes.bbbMetricValue} style={{ fontSize: "0.9rem", minHeight: 28, flexWrap: "wrap", textAlign: "center", lineHeight: 1.3 }}>
                    {item.value}
                  </Typography>
                  <Typography className={classes.bbbMetricLabel}>{item.label}</Typography>
                </Box>
              ))}
            </Box>
          </Grid>
        </Grid>

        {/* Summary */}
        {data.summary && (
          <div className={classes.analysisSection} style={{ marginTop: 12 }}>
            <div className={classes.analysisSectionHeader}>
              <InfoIcon className={classes.smallInfoIcon} />
              <Typography className={classes.analysisSectionTitle}>{t.RISK_SUMMARY}</Typography>
            </div>
            <Typography className={classes.analysisText}>{data.summary}</Typography>
          </div>
        )}

        {/* Crash metrics grid */}
        <Box>
          <Typography className={classes.fieldLabel} style={{ marginBottom: 8 }}>{t.CRASH_METRICS}</Typography>
          <Box className={classes.bbbMetricsGrid} style={{ gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))" }}>
            {metricCards.map((m) => (
              <Box key={m.label} className={classes.bbbMetricItem}>
                <Typography className={classes.bbbMetricValue}>{m.value?.toLocaleString?.() ?? m.value}</Typography>
                <Typography className={classes.bbbMetricLabel}>{m.label}</Typography>
              </Box>
            ))}
            <Box className={classes.bbbMetricItem}>
              <Typography className={classes.bbbMetricValue} style={{ fontSize: "0.9rem" }}>
                {metricsData.hasActiveOosOrder ? t.YES : t.NO}
              </Typography>
              <Typography className={classes.bbbMetricLabel}>{t.ACTIVE_OOS_ORDER}</Typography>
            </Box>
          </Box>
        </Box>

        {/* Risk score components bar breakdown */}
        {data.percentiles && (
          <Box>
            <Typography className={classes.fieldLabel} style={{ marginBottom: 8 }}>{t.RISK_SCORE_COMPONENTS}</Typography>
            <Box>
              {componentKeys.map((key) => {
                const c = data.percentiles[key];
                if (!c) return null;
                const contribution = c.contribution ?? 0;
                const maxContrib = data.compositeScore > 0 ? data.compositeScore : 100;
                const ratio = Math.min(contribution / maxContrib, 1);
                const color = RATING_COLOR[c.rating] || "#3b82f6";
                return (
                  <div key={key} className={classes.componentRow}>
                    <Box style={{ minWidth: 190 }}>
                      <Typography className={classes.componentLabel}>{componentLabels[key]}</Typography>
                      {c.rating && (
                        <span className={getRatingBadgeClass(c.rating, classes)} style={{ marginTop: 2, display: "inline-block" }}>
                          {c.rating}
                        </span>
                      )}
                    </Box>
                    <div className={classes.componentBarWrap}>
                      <div
                        className={classes.componentBarFill}
                        style={{ width: `${Math.max(ratio * 100, contribution > 0 ? 4 : 0)}%`, background: color }}
                      />
                    </div>
                    <Typography className={classes.componentScore}>{contribution.toFixed(1)}</Typography>
                    {c.percentile != null && (
                      <Typography style={{ fontSize: "0.72rem", color: "#9ca3af", minWidth: 50 }}>
                        p{c.percentile}
                      </Typography>
                    )}
                  </div>
                );
              })}
            </Box>
          </Box>
        )}

        {/* Top risk factors */}
        {data.topRiskFactors && data.topRiskFactors.length > 0 && (
          <div className={classes.analysisSection}>
            <Typography className={classes.analysisSectionTitle} style={{ marginBottom: 10 }}>{t.TOP_RISK_FACTORS}</Typography>
            <div className={classes.recommendationsList}>
              {data.topRiskFactors.map((factor, i) => (
                <div key={i} className={classes.recommendationItem}>
                  <ErrorIcon className={`${classes.recommendationIcon} ${classes.analysisIconError}`} />
                  <Typography className={classes.recommendationText}>{factor}</Typography>
                </div>
              ))}
            </div>
          </div>
        )}
      </Box>
    </Box>
  );
}

/* ─────────────────────────────────────────────
   Inspection Analysis
───────────────────────────────────────────── */
function getTrendBadgeClass(trend, classes) {
  switch ((trend || "").toUpperCase()) {
    case "IMPROVING": return classes.trendBadgeImproving;
    case "DEGRADING": return classes.trendBadgeDegrading;
    default: return classes.trendBadgeStable;
  }
}

function getTrendIconClass(trend, classes) {
  switch ((trend || "").toUpperCase()) {
    case "IMPROVING": return classes.iconWrapperSuccess;
    case "DEGRADING": return classes.iconWrapperError;
    default: return classes.iconWrapperBlue;
  }
}

function InspectionAnalysis({ dotNumber, applicationId }) {
  const classes = useStyles();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!dotNumber) { setLoading(false); return; }
    setLoading(true);
    getInspectionTrend(applicationId, dotNumber)
      .then((res) => setData(res))
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, [dotNumber, applicationId]);

  if (loading) return (
    <Box style={{ display: "flex", justifyContent: "center", padding: 24 }}>
      <CircularProgress size={28} />
    </Box>
  );
  if (error || !data || Object.keys(data).length === 0) {
    return (
        <Box className={classes.modernCard}>
          <div className={classes.cardHeader}>
            <div className={classes.cardHeaderLeft}>
              <div className={classes.iconWrapper}>
                <SecurityIcon />
              </div>
              <Typography variant="h6" className={classes.cardTitle}>
                Inspection Analysis
              </Typography>
            </div>
          </div>
          <Box style={{ padding: "16px 24px" }}>
            <Typography style={{ color: "#6b7280", fontSize: "0.875rem" }}>
              No inspection analysis data found for this DOT number.
            </Typography>
          </Box>
        </Box>
    );
  }
  const t = strings.APPLICANT.REPUTATION_REPORT;
  const computedDate = data.computedAt
    ? new Date(data.computedAt).toLocaleDateString("en-US", { day: "numeric", month: "short", year: "numeric" })
    : null;

  const trendBadgeClass = getTrendBadgeClass(data.trendDirection, classes);
  const trendIconClass = getTrendIconClass(data.trendDirection, classes);

  // Monthly timeline chart
  const timeline = data.monthlyTimeline || [];
  const months = timeline.map((m) => m.month);
  const oosRates = timeline.map((m) => parseFloat((m.oosRate * 100).toFixed(2)));
  const inspectionCounts = timeline.map((m) => m.inspections);

  const lineChartOptions = {
    chart: { type: "line", toolbar: { show: false }, zoom: { enabled: false } },
    stroke: { curve: "smooth", width: [2, 1] },
    colors: ["#ef4444", "#3b82f6"],
    xaxis: {
      categories: months,
      labels: { rotate: -45, style: { fontSize: "0.65rem" } },
      tickAmount: 8,
    },
    yaxis: [
      {
        title: { text: "OOS Rate (%)", style: { fontSize: "0.72rem" } },
        labels: { formatter: (v) => `${v}%` },
      },
      {
        opposite: true,
        title: { text: "Inspections", style: { fontSize: "0.72rem" } },
        labels: { style: { fontSize: "0.65rem" } },
      },
    ],
    tooltip: {
      shared: true,
      y: [
        { formatter: (v) => `${v}%` },
        { formatter: (v) => v?.toLocaleString() },
      ],
    },
    legend: { position: "top", fontSize: "0.75rem" },
    grid: { borderColor: "#f3f4f6" },
  };
  const lineChartSeries = [
    { name: "OOS Rate %", type: "line", data: oosRates },
    { name: "Inspections", type: "bar", data: inspectionCounts },
  ];

  const recent = data.periodComparison?.recent || {};
  const prior = data.periodComparison?.prior || {};
  const changes = data.periodComparison?.changes || {};

  const comparisonRows = [
    { label: t.OOS_RATE, recentVal: recent.oosRate != null ? `${(recent.oosRate * 100).toFixed(1)}%` : "—", priorVal: prior.oosRate != null ? `${(prior.oosRate * 100).toFixed(1)}%` : "—", change: changes.oosRate },
    { label: t.VIOLATIONS_PER_INSPECTION, recentVal: recent.violationsPerInspection?.toFixed(2) ?? "—", priorVal: prior.violationsPerInspection?.toFixed(2) ?? "—", change: changes.violationsPerInspection },
    { label: t.AVG_SEVERITY, recentVal: recent.avgSeverity?.toFixed(2) ?? "—", priorVal: prior.avgSeverity?.toFixed(2) ?? "—", change: changes.avgSeverity },
    { label: t.CLEAN_RATE, recentVal: recent.cleanRate != null ? `${(recent.cleanRate * 100).toFixed(1)}%` : "—", priorVal: prior.cleanRate != null ? `${(prior.cleanRate * 100).toFixed(1)}%` : "—", change: changes.cleanRate },
    { label: t.BASIC_CATEGORIES, recentVal: recent.basicCategories ?? "—", priorVal: prior.basicCategories ?? "—", change: changes.basicSpread },
  ];

  const peerCtx = data.peerContext || {};
  const lifetime = data.lifetime || {};

  return (
    <Box className={classes.modernCard}>
      <div className={classes.cardHeader}>
        <div className={classes.cardHeaderLeft}>
          <div className={`${classes.iconWrapper} ${trendIconClass}`}>
            <SecurityIcon />
          </div>
          <div>
            <Typography variant="h6" className={classes.cardTitle}>{t.INSPECTION_ANALYSIS}</Typography>
            {computedDate && (
              <Typography style={{ fontSize: "0.75rem", color: "#6b7280", marginTop: 1 }}>
                {t.COMPUTED} {computedDate}
              </Typography>
            )}
          </div>
        </div>
        <div className={`${classes.badge} ${trendBadgeClass}`}>
          {data.trendDirection}
        </div>
      </div>

      <Box className={classes.contentSectionSpacing}>
        {data.summary && (
          <div className={classes.analysisSection}>
            <div className={classes.analysisSectionHeader}>
              <InfoIcon className={classes.smallInfoIcon} />
              <Typography className={classes.analysisSectionTitle}>{t.RISK_SUMMARY}</Typography>
            </div>
            <Typography className={classes.analysisText}>{data.summary}</Typography>
          </div>
        )}
        {lifetime.totalInspections != null && (
          <Box>
            <Typography className={classes.fieldLabel} style={{ marginBottom: 8 }}>{t.LIFETIME_STATS}</Typography>
            <Box className={classes.bbbMetricsGrid}>
              <Box className={classes.bbbMetricItem}>
                <Typography className={classes.bbbMetricValue}>{lifetime.totalInspections?.toLocaleString()}</Typography>
                <Typography className={classes.bbbMetricLabel}>{t.TOTAL_INSPECTIONS}</Typography>
              </Box>
              <Box className={classes.bbbMetricItem}>
                <Typography className={classes.bbbMetricValue}>{lifetime.totalViolations?.toLocaleString()}</Typography>
                <Typography className={classes.bbbMetricLabel}>{t.TOTAL_VIOLATIONS}</Typography>
              </Box>
              <Box className={classes.bbbMetricItem}>
                <Typography className={classes.bbbMetricValue}>{lifetime.totalOos?.toLocaleString()}</Typography>
                <Typography className={classes.bbbMetricLabel}>{t.TOTAL_OOS}</Typography>
              </Box>
              <Box className={classes.bbbMetricItem}>
                <Typography className={classes.bbbMetricValue} style={{ fontSize: "0.78rem" }}>
                  {lifetime.dateRangeStart} → {lifetime.dateRangeEnd}
                </Typography>
                <Typography className={classes.bbbMetricLabel}>{t.DATA_RANGE}</Typography>
              </Box>
            </Box>
          </Box>
        )}
        {timeline.length > 0 && (
          <Box>
            <Typography className={classes.fieldLabel} style={{ marginBottom: 8 }}>{t.MONTHLY_OOS_RATE_TREND}</Typography>
            <Chart
              options={lineChartOptions}
              series={lineChartSeries}
              type="line"
              height={240}
            />
          </Box>
        )}
        {data.periodComparison && (
          <Box>
            <Typography className={classes.fieldLabel} style={{ marginBottom: 8 }}>{t.PERIOD_COMPARISON}</Typography>
            <Box style={{ overflowX: "auto" }}>
              <table className={classes.comparisonTable}>
                <thead>
                  <tr>
                    <th className={classes.comparisonTh}>Metric</th>
                    <th className={classes.comparisonTh}>{t.RECENT_PERIOD}</th>
                    <th className={classes.comparisonTh}>{t.PRIOR_PERIOD}</th>
                    <th className={classes.comparisonTh}>Change</th>
                  </tr>
                </thead>
                <tbody>
                  {comparisonRows.map((row) => (
                    <tr key={row.label}>
                      <td className={classes.comparisonTd} style={{ fontWeight: 500 }}>{row.label}</td>
                      <td className={classes.comparisonTd}>{row.recentVal}</td>
                      <td className={classes.comparisonTd}>{row.priorVal}</td>
                      <td className={classes.comparisonTd}>
                        {row.change ? (
                          <span className={
                            row.change.direction === "BETTER" ? classes.changeBetter :
                            row.change.direction === "WORSE" ? classes.changeWorse :
                            classes.changeFlat
                          }>
                            {row.change.change}
                          </span>
                        ) : "—"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Box>
          </Box>
        )}
        {peerCtx.peerGroup && (
          <Box>
            <Typography className={classes.fieldLabel} style={{ marginBottom: 8 }}>{t.PEER_CONTEXT}</Typography>
            <Box className={classes.bbbMetricsGrid}>
              <Box className={classes.bbbMetricItem}>
                <Typography className={classes.bbbMetricValue} style={{ fontSize: "0.78rem", flexWrap: "wrap", textAlign: "center", lineHeight: 1.3 }}>
                  {peerCtx.description || peerCtx.peerGroup}
                </Typography>
                <Typography className={classes.bbbMetricLabel}>{t.PEER_GROUP}</Typography>
              </Box>
              <Box className={classes.bbbMetricItem}>
                <Typography className={classes.bbbMetricValue}>{peerCtx.peerGroupSize?.toLocaleString() ?? "—"}</Typography>
                <Typography className={classes.bbbMetricLabel}>{t.PEER_GROUP_SIZE}</Typography>
              </Box>
              <Box className={classes.bbbMetricItem}>
                <Typography className={classes.bbbMetricValue}>{peerCtx.peerAvgOosRate != null ? `${(peerCtx.peerAvgOosRate * 100).toFixed(1)}%` : "—"}</Typography>
                <Typography className={classes.bbbMetricLabel}>{t.PEER_AVG_OOS_RATE}</Typography>
              </Box>
              <Box className={classes.bbbMetricItem}>
                <Typography className={classes.bbbMetricValue}>{peerCtx.recentOosRatePercentile != null ? `p${peerCtx.recentOosRatePercentile}` : "—"}</Typography>
                <Typography className={classes.bbbMetricLabel}>{t.OOS_RATE_PERCENTILE}</Typography>
              </Box>
            </Box>
          </Box>
        )}
        {data.topConcerns && data.topConcerns.length > 0 && (
          <div className={classes.analysisSection}>
            <Typography className={classes.analysisSectionTitle} style={{ marginBottom: 10 }}>{t.TOP_CONCERNS}</Typography>
            <div className={classes.recommendationsList}>
              {data.topConcerns.map((concern, i) => (
                <div key={i} className={classes.recommendationItem}>
                  <InfoIcon className={`${classes.recommendationIcon} ${classes.analysisIconWarning}`} />
                  <Typography className={classes.recommendationText}>{concern}</Typography>
                </div>
              ))}
            </div>
          </div>
        )}
      </Box>
    </Box>
  );
}

function IndeedVerification({ report }) {
  const classes = useStyles();

  if (!report?.reputationReport?.indeedMatch) return null;

  const indeedData = report.reputationReport.indeedMatch;

  const isFound = indeedData.found;
  const isExactMatch = true;

  return (
    <Box className={classes.modernCard}>
      <div className={classes.cardHeader}>
        <div className={classes.cardHeaderLeft}>
          <div className={`${classes.iconWrapper} ${isFound ? classes.iconWrapperSuccess : classes.iconWrapperError}`}>
            <WorkIcon />
          </div>
          <Typography variant="h6" className={classes.cardTitle}>
            {strings.APPLICANT.REPUTATION_REPORT.EMPLOYEE_INSIGHTS_FROM_INDEED}
          </Typography>
        </div>
        <div className={`${classes.badge} ${isFound ? classes.badgeSuccess : classes.badgeError}`}>
          <CheckCircleIcon className={classes.badgeIcon} />
          {isFound ? (isExactMatch ? "Exact Match" : "Found") : "Not Found"}
        </div>
      </div>

      <Box className={classes.contentSectionSpacing}>
        {isFound ? (
          <Box className={classes.contentContainer}>
            <Box>
              <Typography className={classes.fieldLabel}>
                {strings.APPLICANT.REPUTATION_REPORT.COMPANY_NAME_FIELD}
              </Typography>
              <Typography className={classes.fieldValue}>
                {indeedData.companyName}
              </Typography>
            </Box>

            {/* Employee Rating Section */}
            <div className={classes.indeedRatingContainer}>
              <div className={classes.indeedRatingLeft}>
                <StarIcon className={classes.starIcon} />
                <Typography className={classes.indeedRatingScore}>
                  {indeedData.rating}
                </Typography>
                <Typography className={classes.indeedRatingText}>
                  {strings.APPLICANT.REPUTATION_REPORT.OUT_OF_5}
                </Typography>
              </div>
              <div className={classes.divider} />
              <Typography className={classes.indeedReviewsCount}>
                {indeedData.totalReviews?.toLocaleString()} {strings.APPLICANT.REPUTATION_REPORT.EMPLOYEE_REVIEWS}
              </Typography>
            </div>

            {/* Company Metrics */}
            <Box className={classes.indeedMetricsGrid}>
              {indeedData.ceo && (
                <Box className={classes.indeedMetricItem}>
                  <Typography className={classes.indeedMetricValue}>
                    <PersonIcon style={{ width: 20, height: 20, marginRight: 8, color: "#3b82f6" }} />
                    {indeedData.ceo}
                  </Typography>
                  <Typography className={classes.indeedMetricLabel}>
                    {strings.APPLICANT.REPUTATION_REPORT.CEO}
                  </Typography>
                </Box>
              )}

              {indeedData.founded && (
                <Box className={classes.indeedMetricItem}>
                  <Typography className={classes.indeedMetricValue}>
                    <CalendarTodayIcon style={{ width: 20, height: 20, marginRight: 8, color: "#3b82f6" }} />
                    {indeedData.founded}
                  </Typography>
                  <Typography className={classes.indeedMetricLabel}>
                    {strings.APPLICANT.REPUTATION_REPORT.FOUNDED}
                  </Typography>
                </Box>
              )}

              {indeedData.companySize && (
                <Box className={classes.indeedMetricItem}>
                  <Typography className={classes.indeedMetricValue}>
                    <GroupIcon style={{ width: 20, height: 20, marginRight: 8, color: "#3b82f6" }} />
                    {indeedData.companySize}
                  </Typography>
                  <Typography className={classes.indeedMetricLabel}>
                    {strings.APPLICANT.REPUTATION_REPORT.COMPANY_SIZE}
                  </Typography>
                </Box>
              )}
            </Box>

            {/* Headquarters */}
            {indeedData.headquarters && (
              <Box>
                <Typography className={classes.fieldLabel}>
                  Headquarters
                </Typography>
                <div className={classes.addressContainer}>
                  <BusinessCenterIcon className={classes.smallLocationIcon} />
                  <Typography className={classes.fieldText}>
                    {indeedData.headquarters}
                  </Typography>
                </div>
              </Box>
            )}

            {/* View Indeed Profile Button */}
            {indeedData.profileUrl && (
              <div className={classes.actionButtons}>
                <MuiButton
                  className={classes.actionButton}
                  href={indeedData.profileUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  startIcon={<WorkIcon className={classes.websiteIcon} />}
                  endIcon={<LaunchIcon className={classes.smallLaunchIcon} />}
                >
                  {strings.APPLICANT.REPUTATION_REPORT.VIEW_INDEED_PROFILE}
                </MuiButton>
              </div>
            )}
          </Box>
        ) : (
          <div className={classes.notFoundContainer}>
            <InfoIcon className={classes.smallInfoIcon} />
            <Typography className={classes.infoText}>
              {strings.APPLICANT.REPUTATION_REPORT.INDEED_NOT_FOUND_MESSAGE}
            </Typography>
          </div>
        )}
      </Box>
    </Box>
  );
}

function RiskAnalysisSection({ report }) {
  const classes = useStyles();
  if (!report?.reputationReport) return null;

  return report && report.reputationReport ? (
    <Box className={classes.riskAnalysisCard}>
      <div className={classes.riskAnalysisHeader}>
        <div className={classes.riskIconWrapper}>
          <WarningIcon />
        </div>
        <Typography className={classes.riskAnalysisTitle}>
          {strings.APPLICANT.REPUTATION_REPORT.RISK_ANALYSIS}
        </Typography>
      </div>

      <Box className={classes.analysisContainer}>
        <div className={classes.analysisSection}>
          <div className={classes.analysisSectionHeader}>
            <InfoIcon className={classes.smallInfoIcon} />
            <Typography className={classes.analysisSectionTitle}>
              {strings.APPLICANT.REPUTATION_REPORT.REPUTATION_ASSESSMENT}
            </Typography>
          </div>
          <Typography className={classes.analysisText}>
            {report.reputationReport.assessment ||
              strings.APPLICANT.REPUTATION_REPORT.NO_ASSESSMENT_AVAILABLE}
          </Typography>
        </div>

        {report.reputationReport.underwritingRecommendations && (
          <div className={classes.analysisSection}>
            <Typography className={`${classes.analysisSectionTitle} ${classes.analysisUnderwritingTitle}`}>
              {strings.APPLICANT.REPUTATION_REPORT.UNDERWRITING_RECOMMENDATIONS}
            </Typography>
            <div className={classes.recommendationsList}>
              {report.reputationReport.underwritingRecommendations.actionRequired && (
                <div className={classes.recommendationItem}>
                  <ErrorIcon className={`${classes.recommendationIcon} ${classes.analysisIconError}`} />
                  <Typography className={classes.recommendationText}>
                    <strong>{strings.APPLICANT.REPUTATION_REPORT.ACTION_REQUIRED}:</strong>{" "}
                    {report.reputationReport.underwritingRecommendations.actionRequired}
                  </Typography>
                </div>
              )}
              {report.reputationReport.underwritingRecommendations.positive && (
                <div className={classes.recommendationItem}>
                  <CheckIcon className={`${classes.recommendationIcon} ${classes.analysisIconSuccess}`} />
                  <Typography className={classes.recommendationText}>
                    <strong>{strings.APPLICANT.REPUTATION_REPORT.POSITIVE}:</strong>{" "}
                    {report.reputationReport.underwritingRecommendations.positive}
                  </Typography>
                </div>
              )}
              {report.reputationReport.underwritingRecommendations.caution && (
                <div className={classes.recommendationItem}>
                  <WarningIcon className={`${classes.recommendationIcon} ${classes.analysisIconWarning}`} />
                  <Typography className={classes.recommendationText}>
                    <strong>{strings.APPLICANT.REPUTATION_REPORT.CAUTION}:</strong>{" "}
                    {report.reputationReport.underwritingRecommendations.caution}
                  </Typography>
                </div>
              )}
            </div>
          </div>
        )}
      </Box>
    </Box>
  ) : null;
}

function MOTUSVerification({ report }) {
  const classes = useStyles();
  if (!report?.reputationReport?.motusMatch) return null;

  const isFound = report.reputationReport.motusMatch.found;
  const isExactMatch = report.reputationReport.motusMatch.exactMatch;

  return (
    <Box className={classes.modernCard}>
      <div className={classes.cardHeader}>
        <div className={classes.cardHeaderLeft}>
          <div className={`${classes.iconWrapper} ${isFound ? classes.iconWrapperSuccess : classes.iconWrapperError}`}>
            <SecurityIcon />
          </div>
          <Typography variant="h6" className={classes.cardTitle}>
            {strings.APPLICANT.REPUTATION_REPORT.MOTUS_VERIFICATION}
          </Typography>
        </div>
        <div className={`${classes.badge} ${isFound ? classes.badgeSuccess : classes.badgeError}`}>
          <CheckCircleIcon className={classes.badgeIcon} />
          {isFound ? (isExactMatch ? strings.APPLICANT.REPUTATION_REPORT.EXACT_MATCH : strings.APPLICANT.REPUTATION_REPORT.FOUND) : strings.APPLICANT.REPUTATION_REPORT.NOT_FOUND}
        </div>
      </div>

      <Box className={classes.contentSectionSpacing}>
        {isFound ? (
          <Box className={classes.contentContainer}>
            <Box>
              <Typography className={classes.fieldLabel}>
                {strings.APPLICANT.REPUTATION_REPORT.CARRIER_NAME}
              </Typography>
              <Typography className={classes.fieldValue}>
                {report.reputationReport.motusMatch.name}
              </Typography>
            </Box>

            <Box>
              <Typography className={classes.fieldLabel}>
                {strings.APPLICANT.REPUTATION_REPORT.DOT_NUMBER}
              </Typography>
              <Typography className={classes.dotNumber}>
                {report.reputationReport.motusMatch.dot}
              </Typography>
            </Box>

            <Box>
              <Typography className={classes.fieldLabel}>
                {strings.APPLICANT.REPUTATION_REPORT.REGISTERED_ADDRESS}
              </Typography>
              <div className={classes.addressContainer}>
                <LocationOnIcon className={classes.smallLocationIcon} />
                <Typography className={classes.fieldText}>
                  {report.reputationReport.motusMatch.address}
                </Typography>
              </div>
            </Box>
          </Box>
        ) : (
          <div className={classes.notFoundContainer}>
            <InfoIcon className={classes.smallInfoIcon} />
            <Typography className={classes.infoText}>
              {strings.APPLICANT.REPUTATION_REPORT.MOTUS_NOT_FOUND_MESSAGE}
            </Typography>
          </div>
        )}
      </Box>
    </Box>
  );
}


function FMCSAVerification({ report }) {
  const classes = useStyles();
  if (!report?.reputationReport?.fmcsaMatch) return null;

  const isFound = report.reputationReport.fmcsaMatch.found;
  const isExactMatch = report.reputationReport.fmcsaMatch.exactMatch;

  return (
    <Box className={classes.modernCard}>
      <div className={classes.cardHeader}>
        <div className={classes.cardHeaderLeft}>
          <div className={`${classes.iconWrapper} ${isFound ? classes.iconWrapperSuccess : classes.iconWrapperError}`}>
            <SecurityIcon />
          </div>
          <Typography variant="h6" className={classes.cardTitle}>
            {strings.APPLICANT.REPUTATION_REPORT.FMCSA_VERIFICATION}
          </Typography>
        </div>
        <div className={`${classes.badge} ${isFound ? classes.badgeSuccess : classes.badgeError}`}>
          <CheckCircleIcon className={classes.badgeIcon} />
          {isFound ? (isExactMatch ? strings.APPLICANT.REPUTATION_REPORT.EXACT_MATCH : strings.APPLICANT.REPUTATION_REPORT.FOUND) : strings.APPLICANT.REPUTATION_REPORT.NOT_FOUND}
        </div>
      </div>

      <Box className={classes.contentSectionSpacing}>
        {isFound ? (
          <Box className={classes.contentContainer}>
            <Box>
              <Typography className={classes.fieldLabel}>
                {strings.APPLICANT.REPUTATION_REPORT.CARRIER_NAME}
              </Typography>
              <Typography className={classes.fieldValue}>
                {report.reputationReport.fmcsaMatch.name}
              </Typography>
            </Box>

            <Box>
              <Typography className={classes.fieldLabel}>
                {strings.APPLICANT.REPUTATION_REPORT.DOT_NUMBER}
              </Typography>
              <Typography className={classes.dotNumber}>
                {report.reputationReport.fmcsaMatch.dot}
              </Typography>
            </Box>

            <Box>
              <Typography className={classes.fieldLabel}>
                {strings.APPLICANT.REPUTATION_REPORT.REGISTERED_ADDRESS}
              </Typography>
              <div className={classes.addressContainer}>
                <LocationOnIcon className={classes.smallLocationIcon} />
                <Typography className={classes.fieldText}>
                  {report.reputationReport.fmcsaMatch.address}
                </Typography>
              </div>
            </Box>
          </Box>
        ) : (
          <div className={classes.notFoundContainer}>
            <InfoIcon className={classes.smallInfoIcon} />
            <Typography className={classes.infoText}>
              {strings.APPLICANT.REPUTATION_REPORT.FMCSA_NOT_FOUND_MESSAGE}
            </Typography>
          </div>
        )}
      </Box>
    </Box>
  );
}

function BBBVerification({ report }) {
  const classes = useStyles();
  if (!report?.reputationReport?.bbbMatch) return null;

  const bbb = report.reputationReport.bbbMatch;
  const isFound = bbb.found;
  const isExactMatch = bbb.exactMatch;

  const getRatingLetterClass = (letter) => {
    if (!letter) return "";
    if (["A+", "A", "A-"].includes(letter)) return "";
    if (["B+", "B", "B-", "C+", "C", "C-"].includes(letter)) return classes.bbbRatingLetterWarning;
    return classes.bbbRatingLetterError;
  };

  return (
    <Box className={classes.modernCard}>
      <div className={classes.cardHeader}>
        <div className={classes.cardHeaderLeft}>
          <div
            className={`${classes.iconWrapper} ${isFound ? classes.iconWrapperSuccess : classes.iconWrapperNeutral
              }`}
          >
            <VerifiedUserIcon />
          </div>
          <Typography variant="h6" className={classes.cardTitle}>
            {strings.APPLICANT.REPUTATION_REPORT.BBB_VERIFICATION || "BBB Verification"}
          </Typography>
          {isFound && bbb.bbbAccredited !== undefined && (
            <span className={`${classes.bbbAccreditedBadge} ${bbb.bbbAccredited ? classes.bbbAccreditedYes : classes.bbbAccreditedNo}`}>
              {bbb.bbbAccredited
                ? (strings.APPLICANT.REPUTATION_REPORT.ACCREDITED || "Accredited")
                : (strings.APPLICANT.REPUTATION_REPORT.NOT_ACCREDITED || "Not Accredited")}
            </span>
          )}
        </div>
        <div
          className={`${classes.badge} ${isFound ? classes.badgeSuccess : classes.badgeNeutral
            }`}
        >
          <CheckCircleIcon className={classes.badgeIcon} />
          {isFound
            ? (isExactMatch
              ? strings.APPLICANT.REPUTATION_REPORT.EXACT_MATCH
              : strings.APPLICANT.REPUTATION_REPORT.FOUND)
            : strings.APPLICANT.REPUTATION_REPORT.NOT_FOUND}
        </div>
      </div>

      <Box className={classes.contentSectionSpacing}>
        {isFound ? (
          <Box className={classes.contentContainer}>
            <Box>
              <Typography className={classes.fieldLabel}>
                {strings.APPLICANT.REPUTATION_REPORT.BUSINESS_NAME}
              </Typography>
              <Typography className={classes.fieldValue}>
                {bbb.businessName}
              </Typography>
            </Box>

            {/* BBB Rating and Quick Metrics */}
            <Box className={classes.bbbMetricsGrid}>
              {bbb.bbbRatingLetter && (
                <Box className={classes.bbbMetricItem}>
                  <Typography className={`${classes.bbbRatingLetter} ${getRatingLetterClass(bbb.bbbRatingLetter)}`}>
                    {bbb.bbbRatingLetter}
                  </Typography>
                  <Typography className={classes.bbbMetricLabel}>
                    {strings.APPLICANT.REPUTATION_REPORT.BBB_RATING || "BBB Rating"}
                  </Typography>
                </Box>
              )}
              {bbb.yearsInBusiness !== undefined && (
                <Box className={classes.bbbMetricItem}>
                  <Typography className={classes.bbbMetricValue}>
                    {bbb.yearsInBusiness}
                  </Typography>
                  <Typography className={classes.bbbMetricLabel}>
                    {strings.APPLICANT.REPUTATION_REPORT.YEARS_IN_BUSINESS || "Years in Business"}
                  </Typography>
                </Box>
              )}
              {bbb.complaintsTotal !== undefined && (
                <Box className={classes.bbbMetricItem}>
                  <Typography className={classes.bbbMetricValue}>
                    {bbb.complaintsTotal}
                  </Typography>
                  <Typography className={classes.bbbMetricLabel}>
                    {strings.APPLICANT.REPUTATION_REPORT.COMPLAINTS || "Complaints"}
                  </Typography>
                </Box>
              )}
              {bbb.customerReviewCount !== undefined && (
                <Box className={classes.bbbMetricItem}>
                  <Typography className={classes.bbbMetricValue}>
                    {bbb.showCustomerReviewAverage && bbb.averageCustomerReviewScore
                      ? `${bbb.averageCustomerReviewScore} ★`
                      : bbb.customerReviewCount}
                  </Typography>
                  <Typography className={classes.bbbMetricLabel}>
                    {bbb.showCustomerReviewAverage
                      ? `${bbb.customerReviewCount} ${strings.APPLICANT.REPUTATION_REPORT.CUSTOMER_REVIEWS || "Reviews"}`
                      : (strings.APPLICANT.REPUTATION_REPORT.CUSTOMER_REVIEWS || "Customer Reviews")}
                  </Typography>
                </Box>
              )}
            </Box>

            {/* Rating Reasons */}
            {bbb.ratingReasons && bbb.ratingReasons.length > 0 && (
              <Box>
                <Typography className={classes.fieldLabel}>
                  {strings.APPLICANT.REPUTATION_REPORT.RATING_REASONS || "Rating Reasons"}
                </Typography>
                <div className={classes.ratingReasonsList}>
                  {bbb.ratingReasons.map((reason, index) => (
                    <div key={index} className={classes.ratingReasonItem}>
                      <CheckIcon className={classes.ratingReasonIcon} />
                      <Typography>{reason}</Typography>
                    </div>
                  ))}
                </div>
              </Box>
            )}

            {/* Categories */}
            {bbb.businessCategoryNames && bbb.businessCategoryNames.length > 0 && (
              <Box>
                <Typography className={classes.fieldLabel}>
                  {strings.APPLICANT.REPUTATION_REPORT.CATEGORIES || "Categories"}
                </Typography>
                <div className={classes.categoriesList}>
                  {bbb.businessCategoryNames.map((category, index) => (
                    <span key={index} className={classes.categoryChip}>
                      {category}
                    </span>
                  ))}
                </div>
              </Box>
            )}

            {/* Address */}
            <Box>
              <Typography className={classes.fieldLabel}>
                {strings.APPLICANT.REPUTATION_REPORT.REGISTERED_ADDRESS}
              </Typography>
              <div className={classes.addressContainer}>
                <LocationOnIcon className={classes.smallLocationIcon} />
                <Typography className={classes.fieldText}>
                  {bbb.formattedAddress}
                </Typography>
              </div>
            </Box>

            {/* Business Type and File Opened */}
            <Grid container spacing={2}>
              {bbb.businessEntityType && (
                <Grid item xs={6}>
                  <Typography className={classes.fieldLabel}>
                    {strings.APPLICANT.REPUTATION_REPORT.BUSINESS_TYPE || "Business Type"}
                  </Typography>
                  <Typography className={classes.fieldText}>
                    {bbb.businessEntityType}
                  </Typography>
                </Grid>
              )}
              {bbb.bbbFileOpenedDisplay && (
                <Grid item xs={6}>
                  <Typography className={classes.fieldLabel}>
                    {strings.APPLICANT.REPUTATION_REPORT.FILE_OPENED || "File Opened"}
                  </Typography>
                  <Typography className={classes.fieldText}>
                    {bbb.bbbFileOpenedDisplay}
                  </Typography>
                </Grid>
              )}
            </Grid>

            {/* Local BBB */}
            {bbb.localBbbName && (
              <Box>
                <Typography className={classes.fieldLabel}>
                  {strings.APPLICANT.REPUTATION_REPORT.LOCAL_BBB || "Local BBB"}
                </Typography>
                <Typography className={classes.fieldText}>
                  {bbb.localBbbName}
                </Typography>
              </Box>
            )}

            {/* Phone */}
            {bbb.phone && (
              <Box>
                <Typography className={classes.fieldLabel}>
                  Phone
                </Typography>
                <div className={classes.addressContainer}>
                  <PhoneIcon className={classes.smallLocationIcon} />
                  <Typography className={classes.fieldText}>
                    {bbb.phone}
                  </Typography>
                </div>
              </Box>
            )}

            {/* View BBB Profile Button */}
            {bbb.profileUrl && (
              <div className={classes.actionButtons}>
                <MuiButton
                  className={classes.actionButton}
                  href={bbb.profileUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  startIcon={<VerifiedUserIcon className={classes.websiteIcon} />}
                  endIcon={<LaunchIcon className={classes.smallLaunchIcon} />}
                >
                  {strings.APPLICANT.REPUTATION_REPORT.VIEW_BBB_PROFILE || "View BBB Profile"}
                </MuiButton>
              </div>
            )}
          </Box>
        ) : (
          <div className={classes.notFoundContainer}>
            <InfoIcon className={classes.smallInfoIcon} />
            <Typography className={classes.infoText}>
              {strings.APPLICANT.REPUTATION_REPORT.BBB_NOT_FOUND_MESSAGE || "No BBB profile found for this business."}
            </Typography>
          </div>
        )}
      </Box>
    </Box>
  );
}

function PublicPresence({ report, companyPhoto }) {
  const classes = useStyles();
  if (!report?.reputationReport?.googleMatch) return null;

  const getEmbeddableMapUrl = (googleMapsUrl) => {
    if (!googleMapsUrl) return null;

    try {
      const businessName = report.reputationReport.googleMatch.name;
      const address = report.reputationReport.googleMatch.address;

      if (businessName && address) {
        const query = encodeURIComponent(`${businessName}, ${address}`);
        return `https://www.google.com/maps?q=${query}&output=embed`;
      }

      if (googleMapsUrl.includes('google.com/maps')) {
        const url = new URL(googleMapsUrl);
        const searchParams = new URLSearchParams(url.search);
        const q = searchParams.get('q');

        if (q) {
          return `https://www.google.com/maps?q=${encodeURIComponent(q)}&output=embed`;
        }
      }

      return null;
    } catch (error) {
      return null;
    }
  };

  const embeddableMapUrl = getEmbeddableMapUrl(report.reputationReport.googleMatch.googleMapsUrl);
  const isFound = report.reputationReport.googleMatch.found;
  const isExactMatch = report.reputationReport.googleMatch.exactMatch;

  return (
    <Box className={classes.modernCard}>
      <div className={classes.cardHeader}>
        <div className={classes.cardHeaderLeft}>
          <div className={`${classes.iconWrapper} ${isFound ? classes.iconWrapperSuccess : classes.iconWrapperError}`}>
            <PublicIcon />
          </div>
          <Typography variant="h6" className={classes.cardTitle}>
            {strings.APPLICANT.REPUTATION_REPORT.PUBLIC_PRESENCE}
          </Typography>
        </div>
        <div className={`${classes.badge} ${isFound ? classes.badgeSuccess : classes.badgeError}`}>
          <CheckCircleIcon className={classes.badgeIcon} />
          {isFound ? (isExactMatch ? strings.APPLICANT.REPUTATION_REPORT.EXACT_MATCH : strings.APPLICANT.REPUTATION_REPORT.FOUND) : strings.APPLICANT.REPUTATION_REPORT.NOT_FOUND}
        </div>
      </div>

      <Box className={classes.contentSectionSpacing}>
        {isFound ? (
          <Box className={classes.contentContainer}>
            {companyPhoto && (
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <div className={classes.imageContainer}>
                    <img
                      src={companyPhoto}
                      alt={`${report.reputationReport.googleMatch.name} location`}
                      className={classes.companyImage}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <div className={classes.mapContainer}>
                    {embeddableMapUrl ? (
                      <iframe
                        src={embeddableMapUrl}
                        width="100%"
                        height="192"
                        className={classes.mapIframe}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Google Maps Location"
                      />
                    ) : (
                      <Box className={classes.mapPlaceholder}>
                        <Typography variant="caption" color="textSecondary">
                          {strings.APPLICANT.REPUTATION_REPORT.MAP}
                        </Typography>
                      </Box>
                    )}
                  </div>
                </Grid>
              </Grid>
            )}

            <Box>
              <Typography className={classes.fieldLabel}>
                {strings.APPLICANT.REPUTATION_REPORT.BUSINESS_NAME}
              </Typography>
              <Typography className={classes.fieldValue}>
                {report.reputationReport.googleMatch.name}
              </Typography>
            </Box>

            <Box>
              <Typography className={classes.fieldLabel}>
                {strings.APPLICANT.REPUTATION_REPORT.LOCATION}
              </Typography>
              <Box className={classes.locationContainer}>
                <div className={classes.addressContainer}>
                  <LocationOnIcon className={classes.locationIconWithShrink} />
                  <Typography className={classes.fieldText}>
                    {report.reputationReport.googleMatch.address}
                  </Typography>
                </div>
                {report.reputationReport.googleMatch.googleMapsUrl && (
                  <Box className={classes.googleLinkContainer}>
                    <Typography
                      component="a"
                      href={report.reputationReport.googleMatch.googleMapsUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={classes.googleLink}
                    >
                      <LaunchIcon className={classes.smallLaunchIcon} />
                      {strings.APPLICANT.REPUTATION_REPORT.GOOGLE_RESULT}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>

            {(report.reputationReport.googleMatch.rating || report.reputationReport.reputation) && (
              <div className={classes.ratingContainer}>
                <div className={classes.ratingLeft}>
                  <StarIcon className={classes.starIcon} />
                  <Typography className={classes.ratingText}>
                    {report.reputationReport.googleMatch.rating || report.reputationReport.reputation || "N/A"}
                  </Typography>
                </div>
                <div className={classes.divider} />
                <Typography className={classes.ratingsCount}>
                  {report.reputationReport.googleMatch.totalRatings || 0} {strings.APPLICANT.REPUTATION_REPORT.RATINGS}
                </Typography>
              </div>
            )}

            <div className={classes.actionButtons}>
              {report.reputationReport.googleMatch.website && (
                <MuiButton
                  className={classes.actionButton}
                  href={report.reputationReport.googleMatch.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  startIcon={<LanguageIcon className={classes.websiteIcon} />}
                  endIcon={<LaunchIcon className={classes.smallLaunchIcon} />}
                >
                  {strings.APPLICANT.REPUTATION_REPORT.WEBSITE}
                </MuiButton>
              )}
              {report.reputationReport.googleMatch.phone && (
                <MuiButton
                  className={classes.actionButton}
                  href={`tel:${report.reputationReport.googleMatch.phone}`}
                  startIcon={<PhoneIcon className={classes.phoneIcon} />}
                >
                  {strings.APPLICANT.REPUTATION_REPORT.CALL}
                </MuiButton>
              )}
            </div>
          </Box>
        ) : (
          <div className={classes.notFoundContainer}>
            <InfoIcon className={classes.smallInfoIcon} />
            <Typography className={classes.infoText}>
              {strings.APPLICANT.REPUTATION_REPORT.PUBLIC_PRESENCE_NOT_FOUND_MESSAGE}
            </Typography>
          </div>
        )}
      </Box>
    </Box>
  );
}

function parseReputationScore(reputation) {
  if (reputation === null || reputation === undefined || reputation === "") {
    return null;
  }
  const n = typeof reputation === "number" ? reputation : Number(reputation);
  return Number.isFinite(n) ? n : null;
}

function publicReputationDotClass(score, classes) {
  if (score === null) {
    return classes.successDot;
  }
  if (score <= 2) {
    return classes.errorDot;
  }
  if (score <= 3) {
    return classes.warningDot;
  }
  return classes.successDot;
}

function bbbSummaryStatusDotClass(bbbMatch, classes) {
  if (!bbbMatch || !bbbMatch.found) {
    return classes.neutralDot;
  }
  const letter = (bbbMatch.bbbRatingLetter || "").trim().toUpperCase();
  if (letter.startsWith("D") || letter.startsWith("F")) {
    return classes.errorDot;
  }
  if (bbbMatch.bbbAccredited === true && /^A/.test(letter)) {
    return classes.successDot;
  }
  return classes.warningDot;
}

function ReputationalReport(props) {
  const classes = useStyles();
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [statusRes, setStatusRes] = useState(null);
  const [companyPhoto, setCompanyPhoto] = useState(null);
  const { creditCosts, creditUsageEnabled, applicantId, applicationName } = props;
  const [chatStatus, setChatStatus] = useState(null);

  const callGetReputationReport = useCallback(async (applicantId) => {
    setLoading(true);
    getReputationReport(applicantId)
      .then((res) => {
        setReport(res);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const callGetReputationReportStatus = useCallback(async (applicantId) => {
    getReputationReportStatus(applicantId).then((statusRes) => {
      setStatusRes(statusRes.status);
      if (statusRes.status === "COMPLETED") {
        callGetReputationReport(applicantId);
        setLoading(true);
      } else {
        setLoading(false);
      }
    });
    // Also fetch agent chat status
    getAgentChatStatus(applicantId).then((res) => {
      setChatStatus(res);
    }).catch(() => {});
  }, [callGetReputationReport]);

  useEffect(() => {
    if (props.applicantId) {
      callGetReputationReportStatus(props.applicantId);
    }
  }, [props.applicantId, callGetReputationReportStatus]);

  useEffect(() => {
    if (statusRes !== "IN_PROGRESS" || !props.applicantId) {
      return undefined;
    }
    const intervalId = setInterval(() => {
      callGetReputationReportStatus(props.applicantId);
    }, 10000);
    return () => clearInterval(intervalId);
  }, [statusRes, props.applicantId, callGetReputationReportStatus]);

  useEffect(() => {
    const fetchPhoto = async () => {
      if (!props.applicantId) {
        return;
      }

      if (report?.photos?.[0]?.signedUrl) {
        setCompanyPhoto(report.photos[0].signedUrl);
        return;
      }

      if (!report?.reputationReport?.googleMatch?.photoReferences?.[0]) {
        return;
      }

      try {
        const photoId = report.reputationReport.googleMatch.photoReferences[0];
        const photoBlobUrl = await getReputationReportPhoto(props.applicantId, photoId);
        setCompanyPhoto(photoBlobUrl);
      } catch (error) {
        setCompanyPhoto(null);
      }
    };

    if (report && (report?.photos?.[0]?.signedUrl || report?.reputationReport?.googleMatch?.photoReferences?.[0])) {
      fetchPhoto();
    }
  }, [report, props.applicantId]);

  useEffect(() => {
    return () => {
      if (companyPhoto && companyPhoto.startsWith('blob:')) {
        URL.revokeObjectURL(companyPhoto);
      }
    };
  }, [companyPhoto]);

  const handleGetAllDataButton = useCallback(() => {
    setLoading(true);
    requestReputationReport(props.applicantId)
      .then(() => {
        callGetReputationReportStatus(props.applicantId);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [props.applicantId, callGetReputationReportStatus]);

  const getReputationReportCost = useCallback(() => {
    if (creditCosts && Array.isArray(creditCosts)) {
      const costObj = creditCosts.find((cost) => cost.requestType === "REPUTATION_REPORT");
      return costObj ? costObj.creditCost : 0;
    }
    return 0;
  }, [creditCosts]);

  if (loading) {
    return (
      <Box className={classes.root}>
        <Box className={classes.loading}>
          <CircularProgress className="circularLoader" />
        </Box>
      </Box>
    );
  }

  if (!statusRes || statusRes === "NOT_STARTED") {
    return (
      <Box className={classes.root}>
        <ReportEmptyState
          title={strings.APPLICANT.REPUTATION_REPORT.PUBLIC_REPUTATIONAL_REPORT}
          description={strings.APPLICANT.REPUTATION_REPORT.EMPTY_DESCRIPTION}
          action={
            <Button
              onClick={() => handleGetAllDataButton()}
              loading={loading}
              size="large"
              style={{ padding: "12px 32px", fontSize: "1rem" }}
              id="get-all-data"
              endIcon={creditUsageEnabled && creditCosts ? <CreditCost cost={getReputationReportCost()} /> : undefined}
            >
              {strings.APPLICANT.REPUTATION_REPORT.GET_FULL_REPORT_DATA}
            </Button>
          }
        />
      </Box>
    );
  }

  if (statusRes === "IN_PROGRESS" && !report) {
    return (
      <Box className={classes.root}>
        <Box style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 16, padding: 32 }}>
          <CircularProgress className="circularLoader" />
          <Typography variant="h6" className={classes.cardTitle}>
            {strings.APPLICANT.REPUTATION_REPORT.REPORT_IN_PROGRESS_TITLE}
          </Typography>
          <Typography className={classes.infoText} style={{ textAlign: "center", maxWidth: 480 }}>
            {strings.APPLICANT.REPUTATION_REPORT.REPORT_IN_PROGRESS_MESSAGE}
          </Typography>
        </Box>
      </Box>
    );
  }

  if (statusRes === "REPUTATION_FAILED" && !report) {
    return (
      <Box className={classes.root}>
        <Box style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 16, padding: 32 }}>
          <ErrorIcon style={{ color: "#ef4444", fontSize: 40 }} />
          <Typography variant="h6" className={classes.cardTitle}>
            {strings.APPLICANT.REPUTATION_REPORT.REPORT_FAILED_TITLE}
          </Typography>
          <Typography className={classes.infoText} style={{ textAlign: "center", maxWidth: 480 }}>
            {strings.APPLICANT.REPUTATION_REPORT.REPORT_FAILED_MESSAGE}
          </Typography>
          <Button
            onClick={() => handleGetAllDataButton()}
            loading={loading}
            style={{ minWidth: "150px" }}
            id="retry-reputation-report"
            endIcon={
              creditUsageEnabled && creditCosts ? (
                <>
                  {getReputationReportCost()}&nbsp;
                  <Icon folder="icons" fileName="credits.svg" style={{ display: "flex" }} />
                </>
              ) : undefined
            }
          >
            {strings.APPLICANT.REPUTATION_REPORT.RETRY_REPORT}
          </Button>
        </Box>
      </Box>
    );
  }

  return report ? (
    <Box className={classes.root}>
      {AuthService.getClientFeatures().reputationalAiAgent && (
        <AiChat
          applicationId={applicantId}
          applicationName={applicationName}
          chatStatus={chatStatus}
          onRefreshChatStatus={() => getAgentChatStatus(applicantId).then(setChatStatus).catch(() => {})}
          creditCosts={creditCosts}
          creditUsageEnabled={creditUsageEnabled}
        />
      )}
      <Box className={classes.headerContainer}>
        <Typography variant="h6">
          {strings.APPLICANT.REPUTATION_REPORT.PUBLIC_REPUTATIONAL_REPORT}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {strings.APPLICANT.REPUTATION_REPORT.COMPREHENSIVE_VERIFICATION_ANALYSIS}
        </Typography>
      </Box>

      <Box className={classes.companyCard}>
        <div className={classes.companyHeader}>
          <div className={classes.companyIconWrapper}>
            <BusinessIcon />
          </div>
          <div className={classes.companyInfo}>
            <Typography className={classes.companyName}>
              {report.reputationReport.company}
            </Typography>
            <div className={classes.companyAddress}>
              <LocationOnIcon style={{ width: 16, height: 16 }} />
              <Typography style={{ fontSize: "0.875rem", color: "#6b7280" }}>
                {report.reputationReport.address}
              </Typography>
            </div>
          </div>
        </div>

        <div className={classes.metricsGrid}>
          <div className={classes.metricCard}>
            <Typography className={classes.metricLabel}>
              {strings.APPLICANT.REPUTATION_REPORT.REGULATORY_COMPLIANCE}
            </Typography>
            <div className={classes.metricValue}>
              <div className={`${classes.metricDot} ${classes.successDot}`} />
              <Typography className={classes.metricText}>
                {report.reputationReport.regulatoryCompliance}
              </Typography>
            </div>
          </div>

          <div className={classes.metricCard}>
            <Typography className={classes.metricLabel}>
              {strings.APPLICANT.REPUTATION_REPORT.PUBLIC_REPUTATION}
            </Typography>
            <div className={classes.metricValue}>
              {(() => {
                const repScore = parseReputationScore(report.reputationReport.reputation);
                const g = report.reputationReport.googleMatch?.rating;
                return (
                  <>
                    <div className={`${classes.metricDot} ${publicReputationDotClass(repScore, classes)}`}/>
                    <Typography className={classes.metricText}>
                      {repScore === null
                        ? strings.APPLICANT.REPUTATION_REPORT.NOT_AVAILABLE
                        : `${repScore}/5${g != null && g !== "" ? ` (${g} ⭐)` : ""
                        }`}
                    </Typography>
                  </>
                );
              })()}
            </div>
          </div>

          <div className={classes.metricCard}>
            <Typography className={classes.metricLabel}>
              {strings.APPLICANT.REPUTATION_REPORT.OVERALL_RISK}
            </Typography>
            <div className={classes.metricValue}>
              <div className={`${classes.metricDot} ${report.reputationReport.overallRisk <= 1 ? classes.successDot :
                report.reputationReport.overallRisk <= 3 ? classes.warningDot :
                  classes.errorDot
                }`} />
              <Typography className={classes.metricText}>
                {report.reputationReport.overallRisk}/5 - {
                  report.reputationReport.overallRisk <= 1 ? strings.APPLICANT.REPUTATION_REPORT.LOW_RISK_LABEL :
                    report.reputationReport.overallRisk <= 3 ? strings.APPLICANT.REPUTATION_REPORT.MEDIUM_RISK_LABEL :
                      strings.APPLICANT.REPUTATION_REPORT.HIGH_RISK_LABEL
                }
              </Typography>
            </div>
          </div>

          <div className={classes.metricCard}>
            <Typography className={classes.metricLabel}>
              {strings.APPLICANT.REPUTATION_REPORT.BBB}
            </Typography>
            <div className={classes.metricValue}>
              <div
                className={`${classes.metricDot} ${bbbSummaryStatusDotClass(
                  report.reputationReport.bbbMatch,
                  classes
                )}`}
              />
              <div className={classes.metricTextStack}>
                {report.reputationReport.bbbMatch?.found ? (
                  <>
                    <Typography className={classes.metricText}>
                      {(report.reputationReport.bbbMatch.bbbRatingLetter || "").trim() ||
                        strings.APPLICANT.REPUTATION_REPORT.BBB_NOT_RATED}
                    </Typography>
                    <Typography className={classes.metricTextSecondary}>
                      {report.reputationReport.bbbMatch.bbbAccredited === true
                        ? strings.APPLICANT.REPUTATION_REPORT.BBB_ACCREDITED
                        : report.reputationReport.bbbMatch.bbbAccredited === false
                          ? strings.APPLICANT.REPUTATION_REPORT.BBB_NOT_ACCREDITED
                          : strings.APPLICANT.REPUTATION_REPORT.BBB_ACCREDITATION_UNKNOWN}
                      {report.reputationReport.bbbMatch.showCustomerReviewAverage === true &&
                        report.reputationReport.bbbMatch.averageCustomerReviewScore != null
                        ? ` · ${strings.APPLICANT.REPUTATION_REPORT.BBB_REVIEWS_AVG} ${report.reputationReport.bbbMatch.averageCustomerReviewScore}`
                        : ""}
                    </Typography>
                  </>
                ) : (
                  <Typography className={classes.metricText}>
                    {strings.APPLICANT.REPUTATION_REPORT.BBB_NO_LISTING}
                  </Typography>
                )}
              </div>
            </div>
          </div>
        </div>
      </Box>

      <RiskAnalysisSection report={report} />

      <Box className={classes.sectionsSpacing}>
        {report?.reputationReport?.transportationIndustry !== false ? (
          <Grid container spacing={3}>
            {report?.reputationReport?.bbbMatch && (
              <Grid item xs={12}>
                <BBBVerification report={report} />
              </Grid>
            )}
            <Grid item xs={12} md={6}>
              <FMCSAVerification report={report} />
            </Grid>
            <Grid item xs={12} md={6}>
              <MOTUSVerification report={report} />
            </Grid>
            <Grid item xs={12} md={6}>
              <PublicPresence report={report} companyPhoto={companyPhoto} />
            </Grid>
            <Grid item xs={12}>
              <IndeedVerification report={report} />
            </Grid>
            {report?.reputationReport?.fmcsaMatch?.found && 
            report?.reputationReport?.fmcsaMatch?.dot && (
            <Grid item xs={12}>
              <ChameleonCarrier dotNumber={report.reputationReport.fmcsaMatch.dot} applicationId={props.applicantId} />
            </Grid>
             )}
            {report?.reputationReport?.fmcsaMatch?.found && 
            report?.reputationReport?.fmcsaMatch?.dot && (
            <Grid item xs={12}>
              <CrashAnalysis dotNumber={report.reputationReport.fmcsaMatch.dot} applicationId={props.applicantId} />
            </Grid>
            )}
            {report?.reputationReport?.fmcsaMatch?.found && 
            report?.reputationReport?.fmcsaMatch?.dot && (
            <Grid item xs={12}>
              <InspectionAnalysis dotNumber={report.reputationReport.fmcsaMatch.dot} applicationId={props.applicantId} />
            </Grid>
            )}
          </Grid>
        ) : (
          <Grid container spacing={3}>
            {report?.reputationReport?.bbbMatch && (
              <Grid item xs={12} md={6}>
                <BBBVerification report={report} />
              </Grid>
            )}
            <Grid item xs={12} md={6}>
              <PublicPresence report={report} companyPhoto={companyPhoto} />
            </Grid>
            <Grid item xs={12}>
              <IndeedVerification report={report} />
            </Grid>
             {report?.reputationReport?.fmcsaMatch?.found &&
             report?.reputationReport?.fmcsaMatch?.dot && ( 
            <Grid item xs={12}>
              <ChameleonCarrier dotNumber={report.reputationReport.fmcsaMatch.dot} applicationId={props.applicantId} />
            </Grid>
             )}
             {report?.reputationReport?.fmcsaMatch?.found &&
             report?.reputationReport?.fmcsaMatch?.dot && (
            <Grid item xs={12}>
              <CrashAnalysis dotNumber={report.reputationReport.fmcsaMatch.dot} applicationId={props.applicantId} />
            </Grid>
            )}
             {report?.reputationReport?.fmcsaMatch?.found &&
             report?.reputationReport?.fmcsaMatch?.dot && (
            <Grid item xs={12}>
              <InspectionAnalysis dotNumber={report.reputationReport.fmcsaMatch.dot} applicationId={props.applicantId} />
            </Grid>
             )}
          </Grid>
        )}
      </Box>
    </Box>
  ) : null;
}

export default ReputationalReport;
